import {
  CLOSE_CONCURRENT_REMINDER,
  INACTIVE_RENEW_REQUEST,
  INACTIVE_SHOW_MODAL,
  INIT_STATE,
  LOGOUT_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  SESSION_VALIDATE_FAILURE,
  SESSION_VALIDATE_REQUEST,
  SESSION_VALIDATE_SUCCESS,
  SET_TOKEN,
  USER_AUTHENTICATED,
  USER_LOGGEDOUT,
} from './constants';

export const sessionValidateAction = {
  request: () => ({
    type: SESSION_VALIDATE_REQUEST,
  }),
  success: () => ({
    type: SESSION_VALIDATE_SUCCESS,
  }),
  failure: () => ({
    type: SESSION_VALIDATE_FAILURE,
  }),
};

export const renew = () => ({
  type: INACTIVE_RENEW_REQUEST,
});

export const clearError = () => ({
  type: INIT_STATE,
});

export const logoutAction = {
  request: data => ({
    type: LOGOUT_REQUEST,
    data,
  }),
  success: () => ({
    type: LOGOUT_SUCCESS,
  }),
  failure: () => ({
    type: LOGOUT_FAILURE,
  }),
};

export const userAuthenticated = data => ({
  type: USER_AUTHENTICATED,
  data,
});

export const userLoggedOut = data => ({
  type: USER_LOGGEDOUT,
  data,
});

export const setToken = data => ({
  type: SET_TOKEN,
  data,
});

export const inactiveShowModal = data => ({
  type: INACTIVE_SHOW_MODAL,
  data,
});

export const closeConcurrentReminder = () => ({
  type: CLOSE_CONCURRENT_REMINDER,
});
